import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';

export function UnsavedChangesModal({
  open,
  onContinue,
  onDiscard,
}: {
  open: boolean;
  onContinue: () => void;
  onDiscard: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={t('design.unsaved_title')}
      description={t('design.unsaved_body')}
      onClose={onContinue}
      tone="warning"
      showIcon
      role="alertdialog"
      footer={
        <>
          <Button type="button" variant="ghost" onClick={onDiscard}>
            {t('design.unsaved_discard')}
          </Button>
          <Button type="button" variant="primary" onClick={onContinue}>
            {t('design.unsaved_continue')}
          </Button>
        </>
      }
    >
      {null}
    </Modal>
  );
}
